export const ApiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}`;

export const CognitoUserPoolId = `${process.env.REACT_APP_COGNITO_USER_POOL_ID}`;
export const CognitoClientId = `${process.env.REACT_APP_COGNITO_CLIENT_ID}`;
// Local only: floci's Cognito endpoint, and the login flow its pool client allows.
// Unset on dev and prod, where the SDK's defaults (real Cognito, SRP) apply.
export const CognitoEndpoint = process.env.REACT_APP_COGNITO_ENDPOINT || undefined;
export const CognitoAuthFlow = process.env.REACT_APP_COGNITO_AUTH_FLOW || undefined;
